export default "__VITE_ASSET__c767d78d__"